module.exports = __webpack_public_path__ + "static/img/04_innovation.fd04732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/04_innovation.png
// module id = qPwX
// module chunks = 158